import { render, staticRenderFns } from "./addDocumentModal.vue?vue&type=template&id=03d9dcf9"
import script from "./addDocumentModal.vue?vue&type=script&lang=js"
export * from "./addDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./addDocumentModal.vue?vue&type=style&index=0&id=03d9dcf9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports